import { NavLink } from "react-router";

const events = [
	{
		title: "Rehearsal",
		location: "Our Lady of the Snows, Girdwood, AK",
		time: "3/4/26, 2:00 PM, wedding party only",
	},
	{
		title: "Bachelor(ette) Party",
		location: "TBD (Anchorage area)",
		time: "3/5/26, TBD",
	},
	{
		title: "Ceremony",
		location: "Our Lady of the Snows, Girdwood, AK",
		time: "3/6/26, 2:00 PM",
	},
	{
		title: "Reception",
		location: "Alyeska Resort, Girdwood, AK",
		time: "3/6/26, 3:30 PM",
	},
];

export function Home() {
	document.title = "Home | Katelynn & Thomas";

	return (
		<div className="grid grid-cols-1 md:grid-cols-5 p-4 m-auto gap-4 max-w-7xl self-center justify-self-center">
			<div className="col-span-1 md:col-span-3 flex flex-col gap-4">
				<div className="bg-light dark:bg-dark w-full h-auto p-4 flex flex-col gap-4 rounded-2xl drop-shadow-2xl">
					<h2 className="text-5xl text-center font-script">Welcome!</h2>
					<p className="text-lg">
						This is the landing site for the wedding of{" "}
						<strong>Katelynn & Thomas</strong> at the Alyeska Resort in
						Girdwood, AK. We're excited you're here! We know it's a long trip up
						to Alaska, but we want to make it as easy as possible for those who
						can come to make it. Please feel free to peruse our{" "}
						<NavLink to={{ pathname: "/travel" }}>travel guide</NavLink> as you
						make your arrangements. Please reach out if you have any questions!
					</p>
				</div>
				<div className="bg-light dark:bg-dark w-full h-auto p-4 flex flex-col gap-4 rounded-2xl drop-shadow-2xl">
					<h2 className="text-5xl text-center font-script">
						Schedule of Events
					</h2>
					{events.map((event) => (
						<div
							key={event.title}
							className="bg-pink-200 dark:bg-pink-900 w-full h-auto p-4 rounded-xl drop-shadow-md grid grid-cols-5 items-center"
						>
							<div className="flex flex-col col-span-3">
								<h3 className="text-3xl text-left col-span-3 font-script">
									{event.title}
								</h3>
								<h4 className="text-md text-left col-span-3 font-fancy">
									{event.time}
								</h4>
							</div>
							<h3 className="text-2xl text-right col-span-2 font-script">
								{event.location}
							</h3>
						</div>
					))}
				</div>
			</div>
			<div className="col-span-1 md:col-span-2 flex flex-col">
				<div className="overflow-clip rounded-2xl drop-shadow-2xl">
					<img src="/public/front.jpeg" />
				</div>
			</div>
		</div>
	);
}

export default Home;
